<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 w-full px-3 lg:px-10">
          <div class="mt-10 pb-2 flex justify-between">
            <div class="">
              <p class="text-lg text-blues font-semibold">
                Feedback
                <span v-if="feedback_count != null">
                  ({{ feedback_count }})
                </span>
              </p>
            </div>
            <button
              @click="$router.go(-1)"
              class="bg-blues text-xs font-bold text-white px-5 py-1.5 rounded-full"
            >
              Back
            </button>
          </div>

          <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>
          <div class="flex flex-col gap-5">
            <div class="flex flex-wrap gap-4 justify-end">
              <div class="flex flex-wrap gap-2 w-full md:w-[160px]">
                <select
                  ref="selectFilter"
                  name="model_select"
                  id="model_select"
                  v-model="selected_filter"
                  @change="getfeedback(1)"
                  class="px-4 py-2 w-full md:w-[160px] cursor-pointer rounded-full text-sm text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                >
                  <option value="" disabled selected>Select sorting</option>
                  <option value="homework__title">A to Z</option>
                  <option value="-homework__title">Z to A</option>
                </select>
              </div>
              <div class="relative w-full md:max-w-44">
                <form @submit.prevent="getfeedback(1)">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getfeedback(1)"
                    class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-4 w-4 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>

              <div v-if="feedback_list.length > 0"
                @click="feedget()"
                class="bg-blues text-white rounded-2xl py-1 px-5 flex items-center gap-2 cursor-pointer"
              >
                <img src="@/assets/newd/download1.png" alt="" />
                <p class="text-sm text-white">Download</p>
              </div>
            </div>
            <div>
              <div class="overflow-x-auto">
                <table class="table-auto w-full lg:rounded-3xl">
                  <thead>
                    <tr>
                      <th
                        class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC] whitespace-nowrap"
                      >
                        S NO
                      </th>
                      <th
                        class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                      >
                        Title
                      </th>
                      <th
                        class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                      >
                        Feedback Count
                      </th>
                      <th
                        class="p-4 border-b text-center border-r text-blues bg-[#F9FAFC]"
                      >
                        Averge Ratings
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="feedback_list.length > 0">
                    <tr
                      v-for="(feedback, index) in feedback_list"
                      :key="feedback"
                      @click="pushDetailPage(feedback.homework_id)"
                      class="cursor-pointer hover:bg-gray-100 text-xs"
                    >
                      <td class="p-4 border-b text-center border-r">
                        <p class="text-primary">
                          {{ (currentPage - 1) * 10 + index + 1 }}
                        </p>
                      </td>
                      <td
                        class="p-4 border-b text-center border-r lg:max-w-[400px]"
                      >
                        <p class="text-primary line-clamp-3">
                          {{ feedback.homework_title }}
                        </p>
                      </td>
                      <td class="p-4 border-b text-center border-r">
                        <p class="text-primary">
                          {{ feedback.feedback_count }}
                        </p>
                      </td>
                      <td class="p-4 border-b text-center border-r">
                        <div class="text-sm font-bold text-blues">
                          <div
                            class="flex gap-2 items-center flex-wrap justify-center"
                          >
                            <div class="flex justify-center gap-1">
                              <template v-for="i in 5" :key="i">
                                <svg
                                  :class="[
                                    'w-6 h-6 transition',
                                    i <= feedback.average_rating
                                      ? 'text-yellow-400'
                                      : 'text-gray-300',
                                  ]"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                                  />
                                </svg>
                              </template>
                            </div>
                            <p>{{ feedback.average_rating }} Out of 5</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="6" class="px-6 py-3 text-center">
                        No Data Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Pagination
                :totalPages="totalPages"
                ref="paginationRef"
                @page-changed="this.getfeedback"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    SideBar,
    Pagination,
  },
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      feedback_list: [],
      searching: "",
      selected_filter: "",
      feedback_count: null,
      totalPages: 1,
      current_page: 1,
      response_message: "",
    };
  },
  created() {
    this.getfeedback(1);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  props: ["course_id"],
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    pushDetailPage(id) {
      this.$router.push({
        name: "HomeworkSingleFeedback",
        params: { assignment_id: id },
      });
    },
    async getfeedback(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/homework-feedback/summary/course/${this.course_id}/?Key=${this.userInfo.token_key}&page=${page}&search=${this.searching}&ordering=${this.selected_filter}`
        )
        .then((res) => {
          if (res.data.data.status === 200) {
            this.feedback_list = res.data.data.data;
            this.feedback_count = res.data.data.count;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
            console.log("this.feedback_list123", this.feedback_list);
          }
        });
    },
    async feedget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/homework-feedback/download/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
